//Dependencies

import React, { useEffect, useState } from 'react';

//Components

//Styles

import styles from './hero.module.css';

//Assets

import logo from '../../Assets/Logo Circle.png';
import me from '../../Assets/me.jpg';
import illuminate_sentinal from '../../Assets/illuminate.jpg';
import haxguz from '../../Assets/haxguz.jpg';
import melanoma from '../../Assets/melanoma.png';
import consus from '../../Assets/consus.jpg';
import react from '../../Assets/react.png';
import vue from '../../Assets/vue.png';
import express from '../../Assets/express.png';
import node from '../../Assets/node.png';
import mongo from '../../Assets/mongo.png';
import type from '../../Assets/typescript.png';
import git from '../../Assets/git.png';
import framer from '../../Assets/framer.png';
import figma from '../../Assets/figma.png';
import canva from '../../Assets/canva.png';
import icons from '../../Assets/icons.png';
import twitter from '../../Assets/twitter.png';
import github from '../../Assets/github.png';
import linkedin from '../../Assets/linkedin.png';

function Hero() {
  
  const [tab, setTab] = useState('tech');
  const [name, setName] = useState([]);
  const [zoom, setZoom] = useState(false);

  const handleSkillTab = (newTab) => {
    setZoom(true);
    setTimeout(() => {
      setTab(newTab);
      setZoom(false);
    }, 300);
  };

  const handleContactClick = (event) => {
    event.preventDefault();
    window.location.href = 'https://mail.google.com/mail/?view=cm&fs=1&to=adeshssofficial@gmail.com&su=Signup&body=Hit%20it%20up%20for%20any%20queries';
  }

  const nameOnLoad = () => {
    const text = "Adesh S S";
    const textArray = text.split('');
    setName(textArray);
  }

  useEffect(() => {
    nameOnLoad();
  }, []);

  return (
    <div className={styles.main}>

      {/* Hero Section */}

      <div className={styles.hero_section}>
        {/* Header */}

        <div className={styles.hero_section_header}>
          {/* logo container */}

          <div className={styles.hero_section_logo_container}>
            <img src={logo} alt="Logo" />
            <h1>Adesh S S</h1>
          </div>

          {/* Navigation */}

          <div className={styles.hero_section_navigation_container}>
            <a href='#projects'>Projects</a>
            <a href='#capabilities'>Capabilities</a>
            <a href='#tech'>Tech Stack</a>
            <a href='#contact via mail' onClick={handleContactClick}>Contact</a>
          </div>
        </div>

        {/* Hero Section */}

        <div className={styles.hero_section_main}>
          <div className={styles.hero_section_main_left}>
            <h1 className={styles.hero_section_main_left_name}>Howdy, I am 
            {name.map((char, index) => (
              <span key={index} className={styles.char} style={{ animationDelay: `${index * 0.1}s` }}>
                {char}
              </span>
            ))}👋
            </h1>
            <h1 className={`${styles.hero_section_main_left_role} ${styles.delayed}`}>
              Full Stack Developer,
              <br/>Machine Learning Developer
            </h1>
            <h1 className={`${styles.hero_section_main_left_description} ${styles.description_delay}`}>
              Alongside my web development skills, I specialize in creating intelligent 
              solutions with Machine Learning, focusing on enhancing automation and data-
              driven insights. I thrive in dynamic environments and enjoy tackling complex 
              problems with efficient and innovative approaches.
            </h1>

            <div className={`${styles.hero_section_main_left_button_container} ${styles.button_delay}`}>
              <a className={styles.hero_section_main_left_work_button} href='#projects'>View my work</a>
              <a className={styles.hero_section_main_left_me_button} href='#capabilities'>More about me</a>
            </div>
          </div>
          <div className={`${styles.hero_section_main_right} ${styles.hero_delay}`}>
            <img src={me} alt="Me" />
          </div>
        </div>
      </div>

      {/* Projects Section */}

      <div className={styles.projects_section} id='projects'>

        {/* Illuminate Sentinal */}

        <div className={styles.illuminate_sentinal}>
          <div className={styles.illuminate_sentinal_left}>
            <h1>Illuminate Sentinal</h1>
            <p>
              lluminate Sentinel is a surveillance system that monitors forests at night by 
              detecting unauthorized logging activities through captured light signals. 
            </p>
          </div>
          <div className={styles.illuminate_sentinal_right}>
            <img src={illuminate_sentinal} alt="Illuminate Sentinal" />
          </div>
        </div>

        {/* Haxguz */}

        <div className={styles.haxguz}>
          <div className={styles.haxguz_left}>
            <h1>Haxguz</h1>
            <p>
            A Simple Event Management System
            </p>
          </div>
          <div className={styles.haxguz_right}>
            <img src={haxguz} alt="Haxguz" />
          </div>
        </div>

        {/* Melanoma Detection */}

        <div className={styles.melanoma}>
          <div className={styles.melanoma_left}>
            <h1>Melanoma Detection</h1>
            <p>
              A Machine Learning model that detects Melanoma, a type of skin cancer, 
              with an accuracy of 90%.
            </p>
          </div>
          <div className={styles.melanoma_right}>
            <img src={melanoma} alt="Melanoma Detection" />
          </div>
        </div>

        {/* Consus */}

        <div className={styles.consus}>
          <div className={styles.consus_left}>
            <h1>Consus</h1>
            <p>
              An indegenous compiler and assesment platform
            </p>
          </div>
          <div className={styles.consus_right}>
            <img src={consus} alt="Consus" />
          </div>
        </div> 

        {/* Diabetic Retinopathy */}

        <div className={styles.diabetic_retinopathy}>
          <div className={styles.diabetic_retinopathy_left}>
            <h1>Diabetic Retinopathy</h1>
            <p>
              A Machine Learning model that detects Diabetic Retinopathy.
            </p>
          </div>
          <div className={styles.diabetic_retinopathy_right}>
            <img src={melanoma} alt="Diabetic Retinopathy" />
          </div>
        </div>
      </div>

      {/* Capabilities Section */}

      <div className={styles.capabilities_section} id='capabilities'>
        <div className={styles.capabilities_section_header}>
          <h1>Capabilities</h1>
        </div>

        <div className={styles.capabilities_section_main}>
          <div className={styles.capabilities_section_main_left}>
            <h1>Technical Proficiencies</h1>
            <p>Programming Languages: Python, Java, Javascript, C</p>
            <p>Full Stack Development</p>
            <p>Machine Learning</p>
          </div>
          <div className={styles.capabilities_section_main_middle}>
            <h1>Soft Skills</h1>
            <p>Problem Solving</p>
            <p>Team Collaboration</p>
            <p>Communication</p>
          </div>
          <div className={styles.capabilities_section_main_right}>
            <h1>Innovation & Creativity</h1>
            <p>Project Design</p>
            <p>Research & Development</p>
            <p>Product Development</p>
          </div>
        </div>
      </div>

      {/* Skills and Tools Section */}

      <div className={styles.skills_and_tools_section} id='tech'>
        <div className={styles.skills_and_tools_section_header}>
          <h1>Skills & Tools</h1>
          <p>For those who know what they’re looking for..</p>
        </div>

        <div className={styles.skills_and_tools_section_types}> 
          <label for="filter" className={styles.switch} aria-label="Toggle Filter">
            <input type="checkbox" id="filter" />
            <span onClick={() => handleSkillTab('tech')}>Tech</span>
            <span onClick={() => handleSkillTab('design')}>Design</span>
          </label>
        </div>

        <div className={`${styles.skills_and_tools_section_main} ${zoom ? styles.zoom : ''}`}>
          {tab === 'tech' ? (
            <div className={styles.skills_and_tools_section_main_stuff}>
              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={react} alt="React" />
                <h1>React</h1>
              </div>

              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={vue} alt="vue" />
                <h1>Vue</h1>
              </div>

              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={express} alt="Express" />
                <h1>Express</h1>
              </div>

              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={node} alt="Node" />
                <h1>Node</h1>
              </div>

              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={mongo} alt="Mongo" />
                <h1>Mongo</h1>
              </div>

              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={type} alt="type" />
                <h1>Typescript</h1>
              </div>

              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={git} alt="git" />
                <h1>Git</h1>
              </div>

              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={framer} alt="framer" />
                <h1>Framer</h1>
              </div>
            </div>
          ) : (
            <div className={styles.skills_and_tools_section_main_stuff}>
              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={figma} alt="Figma" />
                <h1>Figma</h1>
              </div>

              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={canva} alt="Canva" />
                <h1>Canva</h1>
              </div>

              <div className={styles.skills_and_tools_section_main_stuff_box}>
                <img src={icons} alt="Icons8" />
                <h1>Icons8</h1>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Footer Section */}

      <div className={styles.footer_section}>
        <div className={styles.footer_section_top}>
          <div className={styles.footer_section_top_left}>
            <h1>In need of a developer ?</h1>
            <p className={styles.title}>I’m currently available for work.</p>
            <button onClick={handleContactClick}>Send a message</button>
          </div>
          <div className={styles.footer_section_top_right}>
            <h1>adesh.al22@bitsathy.ac.in</h1>
          </div>
        </div>

        <div className={styles.footer_section_bottom}>
          <div className={styles.footer_section_bottom_left}>
            <h1>Bannari Amman Institute of Technology</h1>
            <h1>Sathyamangalam</h1>
            <h1>Erode</h1>
            <h1>638 401</h1>
          </div>

          <div className={styles.footer_section_bottom_middle}>
            <h1>@2024 Adesh S S</h1>
          </div>

          <div className={styles.footer_section_bottom_right}>
            <a href='https://www.linkedin.com/in/adesh-s-s-1b10b8259'><img className={styles.icons} src={linkedin} alt='linkeden' /></a>
            <a href='https://github.com/Adesh-SS'><img className={styles.icons} src={github} alt='github' /></a>
            <a href='https://x.com/Adesh_SS44'><img className={styles.icons} src={twitter} alt='twitter' /></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;